'use strict'

module.exports = generated

function generated(node) {
  return (
    !node ||
    !node.position ||
    !node.position.start ||
    !node.position.start.line ||
    !node.position.start.column ||
    !node.position.end ||
    !node.position.end.line ||
    !node.position.end.column
  )
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/node_modules/unist-util-generated/index.js
// module id = evFW
// module chunks = 0